import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";

import { Button } from "aible";

import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faCog } from "@fortawesome/free-solid-svg-icons";

class TileHolder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: props.startOpen !== undefined ? props.startOpen : undefined
    };
  }

  render() {
    const { tiles, hideTitle, hideHover, height, openHeight, isOpenUp, onClick } = this.props;
    const { open } = this.state;

    const openTile = open && tiles && tiles[open];

    const openDiv = (
      <div
        className={styles.openTile}
        style={
          open === undefined
            ? { height: "0px" }
            : {
                height: openHeight ? openHeight : openTile && openTile.height ? openTile.height : "50vh"
              }
        }
      >
        <div className={styles.closedButton}>
          <Button type="secondary" onClick={() => this.setState({ open: undefined })}>
            {"Close"}
          </Button>
        </div>
        {tiles &&
          tiles
            .filter((t) => t.isDisabled !== true)
            .map((tile, index) => (
              <div
                className={styles.oTile}
                style={index === open ? { top: "0%", opacity: 1.0 } : { top: isOpenUp ? "100%" : "-100%" }}
                key={index}
              >
                {index === open && tile.open}
              </div>
            ))}
      </div>
    );

    const tileList = (
      <div className={styles.closedTileList}>
        {tiles &&
          tiles
            .filter((t) => t.isDisabled !== true)
            .map((tile, index) => (
              <div
                className={
                  styles.closedTile +
                  " " +
                  (hideHover !== true && tile.hide !== true ? styles.hoverTile : "") +
                  " " +
                  (index === open ? styles.openSmallTile : "")
                }
                onClick={() => tile.open && this.setState({ open: index })}
                style={{
                  width: 100 / (tiles.length + 1) + "%",
                  height: height ? height + "px" : "240px",
                  padding: tile.hide ? "0px" : "5px"
                }}
                key={index}
              >
                {hideTitle !== true && tile.hide !== true && <div className={styles.closedTileLabel}>{tile.title}</div>}
                <div
                  className={
                    styles.closedTileContent +
                    " " +
                    (index === open && tile.hide !== true ? styles.activeTile : "") +
                    " " +
                    (tile.hide ? styles.hideTile : "")
                  }
                  style={hideTitle || tile.hide ? { height: "100%" } : {}}
                >
                  {tile && tile.closed}
                </div>
                {hideTitle !== true && tile.hide !== true && (
                  <div className={styles.absTileFix + " " + (index === open ? styles.activeAbsTileFix : "")} />
                )}
              </div>
            ))}
      </div>
    );

    return (
      <div className={styles.tileHolder}>
        {isOpenUp ? openDiv : tileList}
        {isOpenUp ? tileList : openDiv}
      </div>
    );
  }
}

export default TileHolder;
